import { AppShell } from './AppShell';
import PublicIcon from '@mui/icons-material/Public';
import GavelIcon from '@mui/icons-material/Gavel';
import ArticleIcon from '@mui/icons-material/Article';
import VerifiedIcon from '@mui/icons-material/Verified';
import BugReportIcon from '@mui/icons-material/BugReport';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';

export function RegulationOpsLayout() {
  return (
    <AppShell noHeader
      brand={{
        title: 'RegulationOps',
        subtitle: 'Pillar 9',
        href: '/regulation-ops',
      }}
      sections={[
        {
          items: [
            { to: '/regulation-ops',              label: 'Jurisdictions',  icon: <PublicIcon />, exact: true },
            { to: '/regulation-ops/sources',      label: 'Sources',        icon: <ArticleIcon /> },
            { to: '/regulation-ops/rules',        label: 'Rules',          icon: <GavelIcon /> },
            { to: '/regulation-ops/releases',     label: 'Releases',       icon: <VerifiedIcon /> },
            { to: '/regulation-ops/test-cases',   label: 'Test cases',     icon: <BugReportIcon /> },
            { to: '/regulation-ops/change-requests', label: 'Change requests', icon: <ChangeHistoryIcon /> },
          ],
        },
      ]}
    />
  );
}
